<template>
  <v-row>
    <v-col cols="12" class="text-center">
      <v-progress-circular
        indeterminate
        color="primary"
        size="64"
        width="6"
      ></v-progress-circular>
    </v-col>
    <v-col cols="12">
      <div class="loader-container">
        <transition-group name="slide" tag="div" class="text-wrapper">
          <div
            v-for="(text, index) in [currentText]"
            :key="text + index"
            class="loader-text"
          >
            {{ text }}
          </div>
        </transition-group>
      </div>
    </v-col>
  </v-row>
</template>

<script>
export default {
  data() {
    return {
      currentIndex: 0,
      texts: [
        "Detecting use of Comic Sans...",
        "Assessing cultural fit through emoji usage...",
        "Measuring coffee dependency from project descriptions...",
        "Analyzing likelihood of ghosting the recruiter...",
        "Evaluating creative skills based on font choice...",
        "Checking for excessive use of buzzwords...",
        "Evaluating number of side projects abandoned on GitHub...",
        "Analyzing Stack Overflow copy-paste ratio...",
        "Detecting ‘passionate about coding’ claim...",
        "Flagging overuse of the word ‘ninja’...",
        "Checking for startup trauma...",
        "Assessing likelihood of asking for a raise...",
        "Scanning for DevOps confusion...",
        "Evaluating use of outdated technologies...",
        "Assessing buzzword-to-skill ratio...",
        "Measuring overconfidence in ‘proficient in C++’ claim...",
        "Analyzing use of ‘rockstar’ in job titles...",
        "Checking for excessive use of acronyms...",
        "Detecting ‘Agile’ abuse...",
        "Searching for signs of burnout hidden in language...",
        "Measuring resilience to enterprise meetings...",
        "Checking for unemploynment rebranding as ‘freelance’...",
        "Detecting whether ‘tech lead’ means ‘babysat interns’...",
        "Evaluating loyalty based on number of SaaS tools listed...",
        "Assessing whether ‘self-taught’ means ‘YouTube degree’...",
        "Assessing startup-to-corporate adaptation risk...",
        "Evaluating whether ‘full-stack’ means ‘knows HTML’...",
        "Assessing startup-to-corporate adaptation risk...",
        "Verifying ‘10x engineer’ claim...",
        "Estimating time spent updating LinkedIn titles vs. actual work...",
        "Measuring ‘AI’ buzzword density...",
      ],
      shuffledTexts: [],
    };
  },
  computed: {
    currentText() {
      return this.shuffledTexts[this.currentIndex];
    },
  },
  mounted() {
    this.shuffledTexts = this.texts.sort(() => Math.random() - 0.5);
    this.startLoop();
  },
  methods: {
    startLoop() {
      setInterval(() => {
        this.currentIndex = (this.currentIndex + 1) % this.texts.length;
      }, 4000); // every 3 seconds
    },
  },
};
</script>

<style scoped>
.loader-container {
  height: 70px;
  overflow: hidden;
  position: relative;
  font-size: 1.2em;
  text-align: center;
}

.text-wrapper {
  position: relative;
}

.loader-text {
  position: absolute;
  width: 100%;
  animation: slideDown 0.5s ease;
}

/* Transition-group animations */
.slide-enter-active,
.slide-leave-active {
  transition: transform 0.5s, opacity 0.5s;
}

.slide-enter {
  transform: translateY(-100%);
  opacity: 0;
}

.slide-enter-to {
  transform: translateY(0);
  opacity: 1;
}

.slide-leave {
  transform: translateY(0);
  opacity: 1;
}

.slide-leave-to {
  transform: translateY(100%);
  opacity: 0;
}
</style>
